/* eslint-disable no-undef */
class KeyCloak {
    tenInfo = localStorage.appf_tenant_info? JSON.parse(localStorage.appf_tenant_info):{}
    keycloak_client_id = this.tenInfo.keycloak_client_id;
    keycloak_base_url = this.tenInfo.keycloak_base_url;
    keycloak_realm = this.tenInfo.keycloak_realm;

    login = async (username, password) => {
        try {
            const response = await fetch(`${this.keycloak_base_url}/realms/${this.keycloak_realm}/protocol/openid-connect/token`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                },
                body: new URLSearchParams({
                    grant_type: 'password',
                    client_id: this.keycloak_client_id,
                    scope: 'openid',
                    username,
                    password,
                })
            });
            if (!response.ok) throw new Error(`HTTP ${response.status}`);
            const data = await response.json();
            this.startRefreshToken();
            return data;
        }
        catch (err) {
            this.stopRefreshToken();
            console.log("Login error", err);
            return null;
        }
    }

    getSession = async () => {
        try {
            const token = localStorage.getItem('token');
            const response = await fetch(`${this.keycloak_base_url}/realms/${this.keycloak_realm}/protocol/openid-connect/userinfo`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`,
                }
            });
            if (!response.ok) throw new Error(`HTTP ${response.status}`);
            const data = await response.json();
            this.startRefreshToken();
            return data;
        } catch (err) {
            this.stopRefreshToken();
            console.log("Session error", err);
            return null;
        }
    }

    logout = async () => {
        try {
            const refresh_token = localStorage.getItem('refresh_token');
            const response = await fetch(`${this.keycloak_base_url}/realms/${this.keycloak_realm}/protocol/openid-connect/logout`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                },
                body: new URLSearchParams({
                    refresh_token,
                    client_id: this.keycloak_client_id,
                    scope: 'openid'
                })
            });
            if (!response.ok) throw new Error(`HTTP ${response.status}`);
            const data = await response.json();
            this.stopRefreshToken();
            return data;
        }
        catch (err) {
            console.log("Logout error", err);
            this.stopRefreshToken();
            return null;
        }
    }

    refreshToken = async () => {
        try {
            const refresh_token = localStorage.getItem('refresh_token');
            if (refresh_token) {
                const response = await fetch(`${this.keycloak_base_url}/realms/${this.keycloak_realm}/protocol/openid-connect/token`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded'
                    },
                    body: new URLSearchParams({
                        grant_type: 'refresh_token',
                        refresh_token,
                        client_id: this.keycloak_client_id,
                        scope: 'openid'
                    })
                });
                if (!response.ok) throw new Error(`HTTP ${response.status}`);
                const data = await response.json();
                localStorage.setItem('token', data.access_token);
                localStorage.setItem('refresh_token', data.refresh_token);
            }
        }
        catch (err) {
            console.log("Refresh error", err);
        }
    }

    startRefreshToken() {
        if (!window.refreshIntervalId) {
            console.log("Starting token refresh mechanism");
            const func = this.refreshToken;
            window.refreshIntervalId = window.setInterval(function () {
                func();
            }, 1000 * 60 * 4);//refresh every 4 minutes
        }
    }

    stopRefreshToken() {
        if (window.refreshIntervalId) {
            console.log("Stopping token refresh mechanism");
            clearInterval(window.refreshIntervalId);
            window.refreshIntervalId = null;
        }
    }
}

export default KeyCloak;